import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export function KeywordMapListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.KeywordMapListing', {
		url: '/admin/keyword_maps',
		controllerAs: 'vm',
		controller: KeywordMapListingCtrl,
		templateUrl: '/ng/hub/KeywordMap/Listing/KeywordMapListingCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/KeywordMap/Listing/KeywordMapListingCtrl.css'),
			$title: () => 'Vocabulary Trainer',
		},
	});
}

export class KeywordMapListingCtrl {
	constructor($timeout, $filter, Api, Identity, Logger, modal) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.Logger = Logger;
		this.modal = modal;
		// setup data table
		this.dateFormat = $filter('shDate');
		this.table = {
			columns: [
				{ field: 'scope', label: 'Scope', sortable: false },
				{ field: 'from_word', label: 'When a post contains', sortable: true },
				{ field: 'caseSensitivity', label: 'Case Sensitive?', sortable: false },
				{ field: 'to_tag', label: 'It can be discovered by searching for', sortable: true },
				{ field: 'created_at', label: 'Created At', sortable: true },
			],
			rowAction: this.edit.bind(this),
			transformer: this.transform.bind(this),
			endpoint: '/keyword_maps/search',
			limit: 10,
			filters: {},
			defaultSort: '-created_at',
			bindUrl: 'search',
		};
		this.accountForReprocessing = undefined;
		this.hubForReprocessing = undefined;
	}

	selectAccount(accountId) {
		this.table.filters.hub_id = undefined;
	}

	selectHub(hubId) {
		this.table.filters.account_id = undefined;
	}

	transform(result) {
		result.data.forEach(map => {
			map.caseSensitivity = map.is_case_sensitive ? 'Yes' : 'No';
			map.created_at = this.dateFormat(map.created_at, 'long');
		});
		return result;
	}

	filterByAccount(account) {
		this.table.filters.account_id = account.id;
	}

	filterByHub(hub) {
		this.table.filters.hub_id = hub.id;
	}

	clearSearch() {
		this.table.filters.term = '';
		this.table.filters.account_id = undefined;
		this.table.filters.hub_id = undefined;
	}

	edit(map) {
		this.modal
			.state('hub.loggedin.KeywordMapEdit', {
				injections: { map },
				heading: 'Edit vocabulary word: ' + map.from_word,
				width: 650,
				height: 400,
			})
			.then(
				result => {
					if (result && result.refresh) {
						this.table.filters.cb = (+new Date()).toString(36);
					}
				},
				() => {}
			);
	}

	add() {
		this.modal
			.state('hub.loggedin.KeywordMapAdd', {
				heading: 'Add Vocabulary Word',
				width: 650,
				height: 400,
			})
			.then(
				result => {
					if (result && result.refresh) {
						this.table.filters.cb = (+new Date()).toString(36);
					}
				},
				() => {}
			);
	}

	import() {
		this.modal
			.state('hub.loggedin.KeywordMapImport', {
				heading: 'Import Vocabulary Words',
				width: 900,
				height: 'full',
			})
			.then(
				result => {
					if (result && result.refresh) {
						this.table.filters.cb = (+new Date()).toString(36);
					}
				},
				() => {}
			);
	}

	reprocessAccount() {
		const accountId = this.accountForReprocessing;
		this.pendingJob = true;
		this.Api.submitJob('post', `/v2/keywords/mapper/reprocess/affiliation/${accountId}`)
			.then(response => {
				if (response.data.success === true) {
					response.onJobComplete(() => {
						this.pendingJob = false;
					});
				}
			})
			.catch(error => {
				this.Logger.write('REPROCESS_KEYWORDS_ACCOUNT', 'Error reprocessing mapper tags for account:', error);
			});
	}

	reprocessHub() {
		const hubId = this.hubForReprocessing;
		this.pendingJob = true;
		this.Api.submitJob('post', `/v2/keywords/mapper/reprocess/client/${hubId}`)
			.then(response => {
				if (response.data.success === true) {
					response.onJobComplete(() => {
						this.pendingJob = false;
					});
				}
			})
			.catch(error => {
				this.Logger.write('REPROCESS_KEYWORDS_HUB', 'Error reprocessing mapper tags for hub:', error);
			});
	}
}
